import { graphql } from '@search/gql-client/src';

export const SetSubscriptionFrequencyMutation = graphql`
    mutation SetSubscriptionFrequencyMutation(
        $frequency: FrequencyEnum!,
        $searchId: String!,
        $subscriptionType: Int!
    ) {
        setSubscriptionFrequency(
            frequency: $frequency,
            searchId: $searchId,
            subscriptionType: $subscriptionType
        )
    }
`;
